import { connect } from 'react-redux';
import { registerOrAuthorize, sendCode } from '../../../../actions/phoneAuth';
import { hasRegisterOrAuthErrorSelector, isPhoneAuthValidateFormSubmitting, registerOrAuthErrorSelector, resendTimeoutSelector, sendValidationCodeStatusSelector } from './selectors';
import { ConfirmationCallCodeFormController as Component } from '../../../../components/ConfirmationCallCodeFormController';
import { trackPhoneAuthCallReEnterButtonClick, trackPhoneAuthResendCodeClick } from '../../../../utils/tracking';
export function mapStateToProps(state) {
  return {
    isSubmitting: isPhoneAuthValidateFormSubmitting(state),
    hasCodeError: hasRegisterOrAuthErrorSelector(state),
    codeError: registerOrAuthErrorSelector(state),
    codeTimeout: resendTimeoutSelector(state),
    sendValidationCodeStatus: sendValidationCodeStatusSelector(state)
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    onResendCode: function onResendCode() {
      trackPhoneAuthResendCodeClick();
      dispatch(sendCode());
    },
    onVerify: function onVerify(code) {
      dispatch(registerOrAuthorize({
        code: code
      }));
    },
    onCodeCleared: function onCodeCleared() {
      trackPhoneAuthCallReEnterButtonClick();
    }
  };
}
export var FormContainer = connect(mapStateToProps, mapDispatchToProps)(Component);